module.exports = __webpack_public_path__ + "images/help/icn-flightboard@2x-be91bb801555035c29c0c3c1938217f4.png";